import Delete from "@mui/icons-material/Delete";
import { Button, Divider } from "@mui/material";
import { styled } from "@mui/material/styles";
import { get } from "lodash";
import React from "react";
import BSInput from "../../../common/js/components/BSInput";
import BSSelect from "../../../common/js/components/BSSelect";
import { us_states_options } from "../utils/constants";

const StyledIconButton = styled(Button)(() => ({
    marginLeft: 0,
    marginBottom: "10px",
    padding: 0,
    "&:hover": {
        background: "transparent",
    },
}));

const StyledWrapper = styled("div")(() => ({
    display: "flex",
    justifyContent: "space-between",
    gap: "8px",
}));

const LicenseDetail = (props) => {
    const { element, elementIndex, errors, handleUpdateArrayElement, disableInputs, onDelete } = props;

    return (
        <React.Fragment>
            <StyledWrapper>
                <BSInput
                    id="licenseName"
                    label="LICENSE NAME"
                    placeholder="Enter license name"
                    value={element ? element.licenseName : null}
                    error={get(errors, `licenses.${elementIndex}.licenseName`, null)}
                    onChange={(e) => handleUpdateArrayElement("licenses", elementIndex, e.target.id, e.target.value)}
                    disabled={disableInputs === true}
                    helperText="Required"
                    errorText="Required"
                    extraFormControlStyles={{ flex: "1 1 0" }}
                />

                <div
                    style={{
                        display: "flex",
                        flex: "1 1 0",
                        alignItems: "flex-start",
                    }}
                >
                    <BSInput
                        id="licenseNumber"
                        label="LICENSE NUMBER"
                        placeholder="Enter license number"
                        value={element ? element.licenseNumber : null}
                        error={get(errors, `licenses.${elementIndex}.licenseNumber`, null)}
                        onChange={(e) =>
                            handleUpdateArrayElement("licenses", elementIndex, e.target.id, e.target.value)
                        }
                        disabled={disableInputs === true}
                        helperText="Required"
                        errorText="Required"
                    />
                    {disableInputs !== true && (
                        <StyledIconButton
                            style={{ marginTop: "18px", color: "#9e9e9e" }}
                            onClick={() => onDelete(elementIndex)}
                        >
                            <Delete />
                        </StyledIconButton>
                    )}
                </div>
            </StyledWrapper>
            <StyledWrapper>
                <BSInput
                    id="licenseeName"
                    label="LICENSEE NAME"
                    placeholder="Enter licensee name"
                    value={element ? element.licenseeName : null}
                    error={get(errors, `licenses.${elementIndex}.licenseeName`, null)}
                    onChange={(e) => handleUpdateArrayElement("licenses", elementIndex, e.target.id, e.target.value)}
                    disabled={disableInputs === true}
                    extraFormControlStyles={{ flex: "1 1 0" }}
                />
                <BSInput
                    id="licenseType"
                    label="LICENSE TYPE"
                    placeholder="Enter license type"
                    value={element ? element.licenseType : null}
                    error={get(errors, `licenses.${elementIndex}.licenseType`, null)}
                    onChange={(e) => handleUpdateArrayElement("licenses", elementIndex, e.target.id, e.target.value)}
                    disabled={disableInputs === true}
                    extraFormControlStyles={{ flex: "1 1 0" }}
                />
            </StyledWrapper>
            <div style={{ display: "flex", gap: "8px" }}>
                <BSSelect
                    id="licenseStateCode"
                    label="STATE"
                    value={element ? element.licenseStateCode : null}
                    error={get(errors, `licenses.${elementIndex}.licenseStateCode`, null)}
                    options={us_states_options}
                    onChange={(e) => handleUpdateArrayElement("licenses", elementIndex, e.target.id, e.target.value)}
                    disabled={disableInputs === true}
                    extraFormControlStyles={{ flex: "1 1 0" }}
                    helperText="Required"
                    errorText="Required"
                />
                <BSInput
                    id="expirationDate"
                    label="EXPIRATION DATE (OPTIONAL)"
                    placeholder="Enter expiration date"
                    value={element ? element.expirationDate : null}
                    error={get(errors, `licenses.${elementIndex}.expirationDate`, null)}
                    onChange={(e) => handleUpdateArrayElement("licenses", elementIndex, e.target.id, e.target.value)}
                    disabled={disableInputs === true}
                    extraFormControlStyles={{ flex: "1 1 0" }}
                    type="date"
                />
            </div>
            <BSInput
                id="licenseUrl"
                label="LICENSE URL"
                placeholder="Enter license url"
                value={element ? element.licenseUrl : null}
                error={get(errors, `licenses.${elementIndex}.licenseUrl`, null)}
                onChange={(e) => handleUpdateArrayElement("licenses", elementIndex, e.target.id, e.target.value)}
                disabled={disableInputs === true}
                extraFormControlStyles={{ flex: "1 1 0" }}
            />
            <BSInput
                id="comments"
                label="COMMENTS"
                placeholder="Enter comments"
                value={element ? element.comments : null}
                error={get(errors, `licenses.${elementIndex}.comments`, null)}
                onChange={(e) => handleUpdateArrayElement("licenses", elementIndex, e.target.id, e.target.value)}
                disabled={disableInputs === true}
            />
            <Divider />
            <br />
            <br />
        </React.Fragment>
    );
};

export default LicenseDetail;
